<template>
  <v-app>
    <!--
    <v-navigation-drawer app>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">Fontumi</v-list-item-title>
          <v-list-item-subtitle>¡Hola!</v-list-item-subtitle> 
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item v-for="item in items" :key="item.title" link :to="item.to">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    -->

    <v-app-bar app color="accent" dark>
      <v-img
        class="mr-4"
        max-width="100"
        src="../assets/fontumi-logo-complete.png"
      ></v-img>
      <v-toolbar-title>Botón de llamadas</v-toolbar-title>
      <div class="flex-grow-1"></div>

      <v-btn icon>
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>

      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>

        <v-list class="pa-0">
          <v-list-item>
            <v-list-item-title>Reportar bug</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item @click="signOut()">
            <v-list-item-title>Cerrar sesión</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <Toast />
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { app } from "../lib/firebase";

export default {
  components: {
    Toast: () => import("../components/Toast")
  },

  data: () => ({
    items: [
      {
        title: "Tablero",
        icon: "mdi-view-dashboard",
        to: {
          name: "home"
        }
      }
    ]
  }),

  methods: {
    async signOut() {
      await app.auth().signOut();
      this.$router.push({
        name: "login"
      });
    }
  }
};
</script>
